import { HubAssignmentSourceEnum, IBookingHubDisplay } from "@ryde/shared";

export const isBookingHubDisplay = (
  value: unknown,
): value is IBookingHubDisplay => {
  if (!value || typeof value !== "object") {
    return false;
  }

  const hubDisplay = value as Partial<IBookingHubDisplay>;
  return (
    typeof hubDisplay.hubSource === "string" &&
    Object.values(HubAssignmentSourceEnum).includes(
      hubDisplay.hubSource as HubAssignmentSourceEnum,
    )
  );
};

export const parseBookingHubDisplay = (
  value: unknown,
): IBookingHubDisplay | undefined => {
  return isBookingHubDisplay(value) ? value : undefined;
};

export const getBookingHubSourceLabelKey = (
  hubSource: HubAssignmentSourceEnum,
): string | undefined => {
  switch (hubSource) {
    case HubAssignmentSourceEnum.Stored:
      return "hub.storedHub";

    case HubAssignmentSourceEnum.Calculated:
      return "hub.calculatedHub";

    case HubAssignmentSourceEnum.Skip:
      return "hub.skippedHub";

    default:
      return undefined;
  }
};
